import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';

export default function AppLoading(): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        mt: 5,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
